import React from 'react';
import { useNavigate } from 'react-router-dom';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 *
 * @Description MainMenuCard: Main menu card component used for navigation.
 * @param boolean isVisible: Determines if the menu card is visible. (Required)
 * @param Array permission: List of user permissions. (Required)
 * @param string permissionCheck: Specific permission required to access the menu. (Required)
 * @param string navigateTo: Path to navigate when clicking the menu card. (Required)
 * @param string icon: Icon URL for the menu card. (Required)
 * @param string label: Display label for the menu card. (Required)
 * @param Object hover: Hover state object. (Required)
 * @param Function setHover: Function to update the hover state. (Required)
 * @param boolean permissionCheckRequired: Flag to determine if permission validation is needed. (Required)
 * @param string id: identifier for module card
 * @returns {JSX.Element | null}
 */
const MainMenuCard = ({
    isVisible,
    permission,
    permissionCheck,
    navigateTo,
    icon,
    label,
    hover,
    setHover,
    permissionCheckRequired,
    id,
}) => {
    const navigate = useNavigate();

 // The permission validation will only apply if `permissionCheckRequired` is true.
    if (!isVisible || (permissionCheckRequired && !permission?.includes(permissionCheck))) {
        return null;
    }

    return (
        <div className='menu-icon-grid' id={id}
             onClick={() => {navigate(navigateTo);}}
        >
            <div
                className={`icon-base-grid`}
                onMouseEnter={() =>{
                    setHover({
                        menu: label,
                        url: navigateTo,
                        isMenu: true,
                        img: icon,
                    })
                }}
                onMouseLeave={() => setHover({})}
            >
                <div className='base-img'>
                    <img src={icon} alt={label} />
                </div>
                <div className='base-label'>
                    <p>{label}</p>
                </div>
            </div>
        </div>
    );
};

export default MainMenuCard;
